import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB5BrN0pAed6dnLw4ZkwOqn6ic7fTL7_vE",
  authDomain: "houzzbot.firebaseapp.com",
  projectId: "houzzbot",
  storageBucket: "houzzbot.appspot.com",
  messagingSenderId: "629317833195",
  appId: "1:629317833195:web:122fd6516628438af589ae",
  measurementId: "G-BCMZ5G5NQD"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
export const requestSignInWithPopup = () => signInWithPopup(auth, provider);
